import { useMilestone } from "@faire/deprecated-retailer-visitor-shared/stores/domain/useMilestone";
import { HAS_VISITED_CATEGORY_SEARCH_PAGES } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/HAS_VISITED_CATEGORY_SEARCH_PAGES";
import { useEffect } from "react";

export const useLoggedOutSuppliersPageAnalyticsTracking = () => {
  const { setHasOccurred: setHasVisitedCategorySearchPages } = useMilestone(
    HAS_VISITED_CATEGORY_SEARCH_PAGES
  );

  useEffect(() => {
    setHasVisitedCategorySearchPages();
  }, [setHasVisitedCategorySearchPages]);
};
